let fakeFetch: typeof globalThis.fetch

export const fetch = (input: string, init?: RequestInit) =>
  fakeFetch ? fakeFetch(input, init) : window.fetch(input, init)

export const setFetch = (value: typeof globalThis.fetch) => {
  fakeFetch = value
}
